import { useContext } from "react";
import { SSEContext } from "./SSEContext";

export const useSSE = () => {
  const context = useContext(SSEContext);
  if (!context) {
    throw new Error('useSSE must be used within a SSEProvider');
  }
  return context;
};
